/**
 * If search makes heavy rendering or requests to the API for getting results we have to use delay before it happens
 * */
export const DELAY_BEFORE_SEARCH = 300;
export const DEFAULT_SEARCH_SIZE = 10;